module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/section04_11_american-village-fb1c45f916f425b14965ef5f8eff47f2.jpg";